import {pathOr} from 'ramda';

import {LOCALES} from '@/src/app/constants/locales';
import getRootServerUrl from '@/src/app/utils/getRootServerUrl';
import removeTagsFromString from '@/src/app/utils/removeTagsFromString';

export const transformClinicDataForCard = (clinic, locale = LOCALES.EN) => {
  const clinicImage = clinic?.picture
    ? `${getRootServerUrl()}/${pathOr('', ['picture'], clinic)}`
    : null;

  return {
    id: clinic.user.id,
    name: clinic.organization_name,
    picture: clinic.picture,
    description: clinic.description,
    cityName: pathOr('', ['city', `name_${locale}`], clinic),
    countryName: pathOr('', ['country', `name_${locale}`], clinic),
    biographySanitized: removeTagsFromString(clinic.description) || '',
    image: clinicImage,
    type: 'clinic',
    isFollowed: clinic.is_followed,
    slug: clinic.slug,
  };
};
